import React, { FC } from 'react';
import { FormCheck } from 'react-bootstrap';

export interface Props {
  id: string;
  disabled: boolean;
  checked: boolean;
  label: React.ReactNode;
  onChange: (val: React.ChangeEvent<HTMLInputElement>) => void;
  readOnlyMode?: boolean;
}

const Toggle: FC<Props> = ({ id, disabled, checked, label, onChange, readOnlyMode }: Props) => {
  return (
    <div>
      <FormCheck
        type="switch"
        id={id}
        disabled={disabled || readOnlyMode}
        onChange={onChange}
        checked={checked}
        label={label}
      />
    </div>
  );
};

export default Toggle;
